import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const guarantees = [{
  title: 'Metas claras desde el día uno',
  text: 'Sabés qué hacemos, cuándo y para qué. Sin sorpresas, sin vaguedades.'
}, {
  title: 'Todo explicado, siempre',
  text: 'Cada decisión tiene una razón y te la explicamos. Sin jerga, sin términos que no entendás.'
}, {
  title: 'Sin letra chica',
  text: 'Sabés qué pagás, para qué y cuándo. Todo claro desde el principio.'
}];
export function RiskReversal() {
  return;
}